<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px" class="margin-bottom-4">
  <p class="margin-0 font-bold">Ask AI</p>
  <i class="icon-cross-bold font-md cursor-pointer" (click)="closeDialog()"></i>
</div>

<p class="margin-bottom-2 margin-top-0">Selected text</p>
<div class="selected-section bottom-margin">
  {{ selectedString }}
</div>

<ng-container *ngIf="editting; else contentView">
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px">
    <p class="margin-0 font-bold font-md-static sparro-grey-800">Generating</p>
    <div class="pl1">
      <div class="pl1__a sparro-bg-grey-800"></div>
      <div class="pl1__b sparro-bg-grey-800"></div>
      <div class="pl1__c sparro-bg-grey-800"></div>
    </div>
  </div>
</ng-container>
<ng-template #contentView>
  <ng-container *ngIf="completion; else inputView">
    <p class="margin-bottom-2 margin-top-0">Response</p>
    <div class="res-section">
      <p *ngFor="let line of completion.split('\n')">{{ line }}</p>
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="start center"
      fxLayoutGap="16px"
      class="margin-bottom-4 margin-top-2"
      style="padding: 4px 0">
      <i
        class="icon-copy-bold options-btn"
        matTooltip="Copy"
        matTooltipPosition="below"
        (click)="copiedReply(completion)"></i>
      <i
        class="icon-repeat-bold options-btn"
        matTooltip="Regenerate"
        matTooltipPosition="below"
        (click)="regenerate()">
      </i>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
      <uni-state-button
        default="Insert"
        button_class="secondary"
        customClass="insert-btn"
        (click)="closeDialog('insert_below')">
      </uni-state-button>
      <uni-state-button default="Replace" button_class="primary" (click)="closeDialog('replace')">
      </uni-state-button>
    </div>
  </ng-container>
  <ng-template #inputView>
    <div class="options-container" [matMenuTriggerFor]="menu1" #menuTrigger1="matMenuTrigger">
      Ask Ai to...
    </div>
    <mat-menu #menu1="matMenu">
      <div class="menu-content">
        <ng-container *ngFor="let operation of operations">
          <p class="margin-0 operation-title">{{ operation.title }}</p>
          <ng-container *ngFor="let section of operation.sections">
            <ng-container *ngIf="section?.options; else defaultView">
              <div mat-menu-item [matMenuTriggerFor]="options">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                  <i class="icon-edit-bold"></i>
                  <p class="margin-0">{{ section.title }}</p>
                </div>
              </div>
              <mat-menu #options="matMenu">
                <div class="menu-content">
                  <ng-container *ngFor="let option of section.options">
                    <p mat-menu-item class="margin-0" (click)="editSelectedText(section, option)">
                      {{ option }}
                    </p>
                  </ng-container>
                </div>
              </mat-menu>
            </ng-container>
            <ng-template #defaultView>
              <div
                mat-menu-item
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="12px"
                (click)="editSelectedText(section)">
                <i class="icon-edit-bold"></i>
                <p class="margin-0">{{ section.title }}</p>
              </div>
            </ng-template>
          </ng-container>
          <mat-divider style="margin: 16px 0"></mat-divider>
        </ng-container>
      </div>
    </mat-menu>
  </ng-template>
</ng-template>
